<template lang="pug">
.v-panoramic.panoramic(v-if="block")
	.panoramic__wrapper(v-if="isVisible")
		.panoramic__title(v-if="block.title") {{block.title}}
		iframe.panoramic__frame(v-if="block.src" title="Панорамный обзор" :src="block.src")
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';

export default {
	mixins: [
		sourceMixin
	],

	beforeUnmount() {
		if (this.observer) {
			this.observer.disconnect();
		}
	},

	data() {
		return {
			block: null,
			observer: null,
			isVisible: false
		};
	},

	methods: {
		async onObserver() {
			try {
				if (!this.$el) {
					console.warn('Элемент this.$el не определен.');
					this.isVisible = true;
					return;
				}
				if (typeof IntersectionObserver === 'undefined') {
					console.warn('IntersectionObserver не поддерживается.');
					this.isVisible = true;
					return;
				}
				this.observer = new IntersectionObserver((entries) => {
					entries.forEach(async (entry) => {
						if (entry.isIntersecting) {
							this.isVisible = true;
							this.observer.unobserve(entry.target);
						}
					});
				});
				this.observer.observe(this.$el);
			} catch (error) {
				console.error('Ошибка при создании IntersectionObserver:', error);
				this.isVisible = true;
			}
		},

		dataSet(data) {
			this.block = data;
			this.$nextTick(() => {
				this.onObserver();
			});
		}
	}
};
</script>